import { apiGet } from "./apiClient";

export const historyService = {
  getList,
  getDetail,
};

function getList(mailboxHash, brandHash = "", kind = "all") {
  const params = new URLSearchParams();
  if (mailboxHash) {
    params.set("mailbox", mailboxHash);
  }
  if (brandHash) {
    params.set("brand", brandHash);
  }
  if (kind && kind !== "all") {
    params.set("kind", kind);
  }
  const q = params.toString();
  return apiGet(q ? `/api/v1/history/?${q}` : "/api/v1/history/");
}

function getDetail(inboundHash, brandHash = "") {
  const params = new URLSearchParams();
  if (brandHash) {
    params.set("brand", brandHash);
  }
  const q = params.toString();
  return apiGet(q ? `/api/v1/history/${inboundHash}/?${q}` : `/api/v1/history/${inboundHash}/`);
}
